// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".qrcode-password-container .qrcode-password-info[data-v-ff9e6f6c]{font-size:.18rem;text-align:center;margin:.5rem 0 .2rem .2rem}", ""]);
// Exports
module.exports = exports;
